/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;

const state = {
  tasks: [],
};

const getters = {
  isLoading: (state) => state.loading,
};

const actions = {
  async addItem({ commit }, data) {
    try {
      const response = await axios.post(`${url}/tasks/`, data);
      commit("ADD_ITEM", response.data);
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async updateItem({ commit }, data) {
    try {
      const response = await axios.put(
        `${url}/tasks/${data.id}`,
        data.req_body
      );
      commit("UPDATE_ITEM", response.data.task);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  async deleteItem({ commit }, id) {
    try {
      const response = await axios.delete(`${url}/task/${id}`);
      commit("DELETE_ITEM", response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  ADD_ITEM(state, data) {
    state.tasks.push(data);
  },

  UPDATE_ITEM(state, data) {
    state.tasks.splice(state.tasks.findIndex((task) => task._id === data._id));
  },

  DELETE_ITEM(state, id) {
    state.tasks.splice(
      state.tasks.findIndex((task) => task._id === id),
      1
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
